import React from 'react';
import { useTenant } from '../../../context/TenantContext';
import { parseEm } from '../inlineEm';
import { CtaLink } from './links';
import { CTA, HERO } from './content';
import { REVISE_ANCHORS } from './sectionMeta';

/** Closing band. Repeats the hero's *argument*, but not its destination: the
 *  hero opens the demo further down this page, and someone who has reached the
 *  bottom has already passed it, so sending them back up would be a loop. The
 *  closing button goes to the catalogue. It still falls back to the hero's href
 *  when no `cta.ctaHref` is set, which is what the other themes rely on. */
export const ReviseCTASection: React.FC = () => {
  const { tenant } = useTenant();
  const marketing = tenant?.branding.marketing;
  const cta = marketing?.cta ?? {};

  const eyebrow = cta.eyebrow || CTA.eyebrow;
  const headline = cta.headline || CTA.headline || '';
  const body = cta.body || CTA.body;
  const buttonText = cta.buttonText || CTA.buttonText || 'Start free';
  const href =
    cta.ctaHref || CTA.ctaHref || marketing?.hero?.ctaHref || HERO.ctaHref || '#try';

  if (!headline) return null;

  return (
    <section className="rv-sec rv-start rv-band-centre" id={REVISE_ANCHORS.cta} data-accent="essay">
      <div className="rv-wrap">
        <div className="rv-head">
          {eyebrow && <p className="rv-kicker">{eyebrow}</p>}
          <h2>{parseEm(headline)}</h2>
          {body && <p className="rv-p">{body}</p>}
        </div>
        <div className="rv-ctas">
          <CtaLink className="rv-btn rv-btn-primary" href={href}>
            {buttonText}
          </CtaLink>
        </div>
      </div>
    </section>
  );
};
